let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ixq83")).then(() => parcelRequire('5d8Ou'));